/* =========================================================
   NVQ WINKELMANDJE — eigen zijlade
   Werkt samen met:
     sections/nvq-cart-drawer.liquid  (opbouw)
     assets/nvq-cart-drawer.css       (opmaak)
   ========================================================= */

(function () {
  'use strict';

  if (window.NvqCart) return;

  var SECTION = 'nvq-cart-drawer';
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var drawer = null;
  var dialog = null;
  var content = null;
  var keydownHandler = null;
  var lastFocused = null;
  var closeTimer = null;
  var busy = false;
  var ownRequest = false;
  var lastSourceImage = null;
  var introTimer = null;
  var pendingCode = null;

  /* ---------------------------------------------------------
     Basis
  --------------------------------------------------------- */

  function root() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function animationsOn() {
    if (!drawer) return false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    return drawer.getAttribute('data-nvq-cd-animations') === 'true';
  }

  function setBusy(state) {
    busy = state;
    if (drawer) drawer.setAttribute('data-nvq-cd-busy', state ? 'true' : 'false');
  }

  /* ---------------------------------------------------------
     Openen en sluiten
  --------------------------------------------------------- */

  function trap(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;

    var items = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function open() {
    if (!drawer) return;

    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    if (drawer.getAttribute('data-nvq-cd-open') === 'true') return;

    lastFocused = document.activeElement;
    drawer.setAttribute('data-nvq-cd-open', 'true');
    document.body.setAttribute('data-nvq-cd-locked', 'true');

    /* Tijdens het openen mogen de aanbevelingen na het mandje binnenrollen.
       Zodra dat klaar is halen we de vlag weg, zodat een latere wijziging in
       het mandje de beweging niet opnieuw afspeelt. */
    if (introTimer) clearTimeout(introTimer);
    drawer.setAttribute('data-nvq-cd-intro', 'true');
    introTimer = setTimeout(function () {
      drawer.removeAttribute('data-nvq-cd-intro');
      introTimer = null;
    }, 1600);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.setAttribute('data-nvq-cd-visible', 'true');
      });
    });

    keydownHandler = trap;
    document.addEventListener('keydown', keydownHandler);

    var closeButton = dialog.querySelector('.nvq-cd__close');
    if (closeButton) closeButton.focus();
  }

  function close() {
    if (!drawer || drawer.getAttribute('data-nvq-cd-open') !== 'true') return;

    drawer.setAttribute('data-nvq-cd-visible', 'false');
    drawer.removeAttribute('data-nvq-cd-intro');
    document.body.removeAttribute('data-nvq-cd-locked');

    if (introTimer) {
      clearTimeout(introTimer);
      introTimer = null;
    }

    if (keydownHandler) {
      document.removeEventListener('keydown', keydownHandler);
      keydownHandler = null;
    }

    closeTimer = setTimeout(function () {
      drawer.setAttribute('data-nvq-cd-open', 'false');
      closeTimer = null;
    }, 460);

    if (lastFocused && typeof lastFocused.focus === 'function' && document.contains(lastFocused)) {
      lastFocused.focus();
    }
    lastFocused = null;
  }

  /* ---------------------------------------------------------
     Inhoud verversen
  --------------------------------------------------------- */

  /* Zonder aanbevelingspaneel ernaast blijft de lade smal. */
  function syncWidth() {
    if (!drawer || !content) return;
    var side = content.querySelector('.nvq-cd__upsells:not(.nvq-cd__upsells--inline)');
    drawer.setAttribute('data-nvq-cd-wide', side ? 'true' : 'false');
  }

  function readState() {
    if (!content) return {};
    var total = content.querySelector('[data-nvq-cd-subtotal]');
    var bar = content.querySelector('.nvq-cd__shipping-bar');
    return {
      total: total ? total.textContent.trim() : '',
      reached: bar ? bar.getAttribute('data-nvq-cd-reached') === 'true' : false,
    };
  }

  function applyHtml(html) {
    if (!content || !html) return;

    var before = readState();

    var holder = document.createElement('div');
    holder.innerHTML = html;
    var fresh = holder.querySelector('[data-nvq-cd-content]');
    if (!fresh) return;

    content.innerHTML = fresh.innerHTML;
    syncWidth();

    var after = readState();

    /* Bedrag veranderd: knop even laten kloppen. */
    if (animationsOn() && before.total && after.total && before.total !== after.total) {
      var button = content.querySelector('[data-nvq-cd-checkout]');
      if (button) {
        button.setAttribute('data-nvq-cd-bump', 'true');
        setTimeout(function () { button.removeAttribute('data-nvq-cd-bump'); }, 500);
      }
    }

    /* Net gratis verzending gehaald: korte gloed om de balk. */
    if (animationsOn() && after.reached && before.reached === false) {
      var bar = content.querySelector('.nvq-cd__shipping-bar');
      if (bar) {
        bar.setAttribute('data-nvq-cd-celebrate', 'true');
        setTimeout(function () { bar.removeAttribute('data-nvq-cd-celebrate'); }, 950);
      }
    }

    updateCartCount();
  }

  function refresh() {
    return fetch(root() + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { applyHtml(data[SECTION]); })
      .catch(function () {});
  }

  /* ---------------------------------------------------------
     Winkelwagen wijzigen
  --------------------------------------------------------- */

  function post(url, body) {
    setBusy(true);
    ownRequest = true;
    body.sections = SECTION;

    return fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections[SECTION]) {
          applyHtml(data.sections[SECTION]);
        } else {
          return refresh();
        }
      })
      .catch(function () { return refresh(); })
      .then(function () {
        setBusy(false);
        ownRequest = false;
      });
  }

  function changeLine(line, quantity) {
    return post('cart/change.js', { line: line, quantity: quantity });
  }

  function addVariant(id, quantity) {
    return post('cart/add.js', { items: [{ id: id, quantity: quantity || 1 }] });
  }

  function emptyCart() {
    return post('cart/clear.js', {});
  }

  /* ---------------------------------------------------------
     Kortingscode
  --------------------------------------------------------- */

  /* Shopify heeft hier geen ajax-adres voor. Het adres /discount/CODE zet de
     code op het mandje en stuurt daarna door; wij vangen dat op met
     redirect=cart.js zodat er geen hele pagina wordt opgehaald. Daarna halen
     we de lade opnieuw op en staat de korting erin. */
  function sendCode(code) {
    var target = encodeURIComponent(root() + 'cart.js');
    return fetch(root() + 'discount/' + encodeURIComponent(code) + '?redirect=' + target, {
      credentials: 'same-origin',
    })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  /* Het antwoord van cart.js vertelt of de code echt geldig was.
     true = gelukt, false = niet gelukt, null = niet te zeggen. */
  function codeAccepted(cartData, code) {
    if (!cartData || !cartData.discount_codes) return null;

    for (var i = 0; i < cartData.discount_codes.length; i++) {
      var entry = cartData.discount_codes[i];
      if (!entry || !entry.code) continue;
      if (String(entry.code).toLowerCase() === code.toLowerCase()) {
        return entry.applicable !== false;
      }
    }
    return false;
  }

  function discountBox() {
    return content ? content.querySelector('[data-nvq-cd-discount]') : null;
  }

  /* Na het verversen: gelukt, of toch een melding onder het veld? */
  function reportCode(accepted) {
    var code = pendingCode;
    pendingCode = null;
    if (!code) return;

    var box = discountBox();
    if (!box) return;

    /* Kon het antwoord van de winkel niets zeggen, dan kijken we of de
       lade nu de code laat zien. */
    if (accepted === null || typeof accepted === 'undefined') {
      accepted = box.getAttribute('data-nvq-cd-discount-active') === 'true';
    }
    if (accepted) return;

    var input = box.querySelector('[data-nvq-cd-discount-input]');
    var note = box.querySelector('[data-nvq-cd-discount-note]');

    if (input) {
      input.value = code;
      input.focus();
    }
    if (note) {
      note.textContent = box.getAttribute('data-nvq-cd-discount-error') || '';
      note.hidden = false;
    }
  }

  function applyDiscount(code) {
    code = (code || '').trim();
    if (!code || busy) return;

    var box = discountBox();
    var button = box ? box.querySelector('[data-nvq-cd-discount-apply]') : null;
    var note = box ? box.querySelector('[data-nvq-cd-discount-note]') : null;
    if (button) button.setAttribute('data-nvq-cd-state', 'loading');
    if (note) note.hidden = true;

    pendingCode = code;
    setBusy(true);

    var accepted = null;

    return sendCode(code)
      .then(function (cartData) {
        accepted = codeAccepted(cartData, code);
        return refresh();
      })
      .then(function () {
        setBusy(false);
        reportCode(accepted);
      });
  }

  function removeDiscount() {
    if (busy) return;
    setBusy(true);
    pendingCode = null;

    /* Een mandje kan maar een kortingscode bevatten. Door een code te sturen
       die niet bestaat, valt de vorige weg. Dat is de enige manier om hem
       weer te wissen. */
    return sendCode('nvq-ingen-rabattkod')
      .then(function () { return refresh(); })
      .then(function () { setBusy(false); });
  }

  /* Voorkom dat het mandje twee keer tegelijk opengaat wanneer zowel de
     snelkooplade als de netwerkbewaking hetzelfde toevoegen opmerkt. */
  var openPending = false;

  function refreshAndOpen(delay) {
    if (openPending) return;
    openPending = true;
    setTimeout(function () {
      refresh().then(function () {
        open();
        openPending = false;
      });
    }, delay || 0);
  }

  /* ---------------------------------------------------------
     Winkelwagenteller in de kop
  --------------------------------------------------------- */

  function updateCartCount() {
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
          bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        });
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function bumpCartIcon() {
    if (!animationsOn()) return;
    var icon = document.querySelector('.js-drawer-open-cart .cart-link, .js-drawer-open-cart');
    if (!icon) return;
    icon.classList.remove('nvq-cd-cart-bump');
    void icon.offsetWidth;
    icon.classList.add('nvq-cd-cart-bump');
    setTimeout(function () { icon.classList.remove('nvq-cd-cart-bump'); }, 560);
  }

  /* ---------------------------------------------------------
     Productfoto die naar het winkelmandje vliegt
  --------------------------------------------------------- */

  function flyToCart(image) {
    if (!animationsOn() || !image) return;

    var target = document.querySelector('.js-drawer-open-cart');
    if (!target) return;

    var from = image.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !from.height) return;

    var ghost = document.createElement('img');
    ghost.src = image.currentSrc || image.src;
    ghost.className = 'nvq-cd-fly';
    ghost.style.left = from.left + 'px';
    ghost.style.top = from.top + 'px';
    ghost.style.width = from.width + 'px';
    ghost.style.height = from.height + 'px';
    document.body.appendChild(ghost);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);

    requestAnimationFrame(function () {
      ghost.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.12)';
      ghost.style.opacity = '0.2';
    });

    setTimeout(function () {
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      bumpCartIcon();
    }, 720);
  }

  function rememberSource(element) {
    if (!element) return;
    var card = element.closest('[data-nvq-product-card], .nvq-cd-upsell, [data-nvq-qb-content], .grid-product');
    var image = card ? card.querySelector('img') : null;
    lastSourceImage = image || null;
  }

  /* ---------------------------------------------------------
     Klikafhandeling
  --------------------------------------------------------- */

  function onClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    /* Sluiten */
    if (target.closest('[data-nvq-cd-close]')) {
      event.preventDefault();
      close();
      return;
    }

    /* Aantal wijzigen of regel verwijderen */
    var qtyButton = target.closest('[data-nvq-cd-qty]');
    if (qtyButton && !busy) {
      event.preventDefault();
      var quantity = parseInt(qtyButton.getAttribute('data-nvq-cd-qty'), 10);
      var line = parseInt(qtyButton.getAttribute('data-nvq-cd-line'), 10);
      if (isNaN(quantity) || isNaN(line)) return;

      var row = qtyButton.closest('[data-nvq-cd-item]');
      if (quantity === 0 && row && animationsOn()) {
        row.setAttribute('data-nvq-cd-leaving', 'true');
        setTimeout(function () { changeLine(line, 0); }, 260);
      } else {
        var value = row ? row.querySelector('[data-nvq-cd-qty-value]') : null;
        if (value && animationsOn()) {
          value.setAttribute('data-nvq-cd-pop', 'true');
        }
        changeLine(line, quantity);
      }
      return;
    }

    /* Alles verwijderen */
    if (target.closest('[data-nvq-cd-remove-all]') && !busy) {
      event.preventDefault();
      emptyCart();
      return;
    }

    /* Fraktskydd aan of uit */
    var toggle = target.closest('[data-nvq-cd-protection]');
    if (toggle && !busy) {
      event.preventDefault();
      var on = toggle.getAttribute('aria-checked') === 'true';
      toggle.setAttribute('aria-checked', on ? 'false' : 'true');

      if (on) {
        var protectionLine = parseInt(toggle.getAttribute('data-nvq-cd-line'), 10);
        if (protectionLine > 0) changeLine(protectionLine, 0);
      } else {
        addVariant(toggle.getAttribute('data-nvq-cd-variant'), 1);
      }
      return;
    }

    /* Aanbeveling toevoegen */
    var upsell = target.closest('[data-nvq-cd-upsell]');
    if (upsell && !busy) {
      event.preventDefault();
      var variant = upsell.getAttribute('data-nvq-cd-variant');

      if (variant) {
        upsell.setAttribute('data-nvq-cd-state', 'loading');
        rememberSource(upsell);
        flyToCart(lastSourceImage);
        addVariant(variant, 1).then(function () {
          upsell.removeAttribute('data-nvq-cd-state');
        });
      } else if (window.NvqQuickBuy) {
        close();
        window.NvqQuickBuy.open(upsell.getAttribute('data-nvq-cd-url'));
      } else {
        window.location.href = upsell.getAttribute('data-nvq-cd-url');
      }
      return;
    }

    /* Kortingscode toepassen of weghalen */
    var codeButton = target.closest('[data-nvq-cd-discount-apply]');
    if (codeButton && !busy) {
      event.preventDefault();
      var codeBox = codeButton.closest('[data-nvq-cd-discount]');
      var codeInput = codeBox ? codeBox.querySelector('[data-nvq-cd-discount-input]') : null;
      applyDiscount(codeInput ? codeInput.value : '');
      return;
    }

    if (target.closest('[data-nvq-cd-discount-remove]') && !busy) {
      event.preventDefault();
      removeDiscount();
      return;
    }

    /* Onthoud waar een toevoeging vandaan komt, voor de vliegende foto */
    if (target.closest('[data-nvq-qb-trigger], [data-nvq-qb-atc], [type="submit"][name="add"]')) {
      rememberSource(target);
      return;
    }

    /* Winkelwagenlink van het thema overnemen */
    var cartLink = target.closest('.js-drawer-open-cart, a[href$="/cart"], a[href*="/cart?"]');
    if (cartLink && drawer) {
      event.preventDefault();
      event.stopPropagation();
      refreshAndOpen(0);
    }
  }

  /* ---------------------------------------------------------
     Toevoegingen van elders opmerken (productpagina, snelkoop)
  --------------------------------------------------------- */

  function watchAddToCart() {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch !== 'function') return;

    window.fetch = function () {
      var args = arguments;
      var url = '';
      try {
        url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      } catch (e) {
        url = '';
      }

      var promise = nativeFetch.apply(this, args);

      if (url.indexOf('/cart/add') !== -1 && !ownRequest) {
        promise
          .then(function (response) {
            if (!response || !response.ok) return;
            flyToCart(lastSourceImage);
            refreshAndOpen(animationsOn() ? 520 : 0);
          })
          .catch(function () {});
      }

      return promise;
    };

    /* Sommige thema-onderdelen gebruiken nog de oude manier van verzenden. */
    var nativeOpen = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
    if (typeof nativeOpen === 'function') {
      window.XMLHttpRequest.prototype.open = function (method, url) {
        this.__nvqCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
        return nativeOpen.apply(this, arguments);
      };

      var nativeSend = window.XMLHttpRequest.prototype.send;
      window.XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        if (xhr.__nvqCartAdd && !ownRequest) {
          xhr.addEventListener('load', function () {
            if (xhr.status < 200 || xhr.status >= 300) return;
            flyToCart(lastSourceImage);
            refreshAndOpen(animationsOn() ? 520 : 0);
          });
        }
        return nativeSend.apply(this, arguments);
      };
    }
  }

  /* ---------------------------------------------------------
     Start
  --------------------------------------------------------- */

  function init() {
    drawer = document.querySelector('[data-nvq-cd]');
    if (!drawer) return;

    dialog = drawer.querySelector('.nvq-cd__dialog');
    content = drawer.querySelector('[data-nvq-cd-content]');

    document.body.setAttribute('data-nvq-cd-active', 'true');
    document.addEventListener('click', onClick, true);
    syncWidth();

    /* Enter in het kortingsveld werkt hetzelfde als op de knop klikken. */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || !event.target || !event.target.closest) return;
      var input = event.target.closest('[data-nvq-cd-discount-input]');
      if (!input) return;
      event.preventDefault();
      applyDiscount(input.value);
    });

    /* De snelkooplade vraagt via dit signaal om het mandje te openen. */
    document.addEventListener('nvq:cart:open', function () {
      refreshAndOpen(0);
    });

    watchAddToCart();
    updateCartCount();
  }

  window.NvqCart = {
    open: function () { refresh().then(open); },
    close: close,
    refresh: refresh,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
